import * as React from "react";

function SvgLearndot(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 118 118"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <g transform="translate(.337 .337)" fillRule="nonzero" fill="none">
        <circle fill="#FF6E07" cx={58.344} cy={58.344} r={58.344} />
        <g fill="#FFF">
          <path d="M32.323 19.954h18.67v75.73h-18.67zM56.594 81.331c0 8.169 6.65 14.703 14.702 14.703C79.464 96.034 86 89.383 86 81.331c0-8.168-6.651-14.702-14.703-14.702-8.051 0-14.702 6.651-14.702 14.702" />
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgLearndot);
